module.exports = __webpack_public_path__ + "beach.ada97063af8d3f269eaffde88483a46a.png";